import * as React from 'react'
import createSvgIcon from './createSvgIcon'
import styled from 'styled-components/macro'

const SendMessageIcon = createSvgIcon(
  <React.Fragment>
    <path
      stroke="var(--text-heading)"
      strokeWidth="2"
      d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z"
    />
    <path stroke="var(--text-heading)" strokeWidth="2" d="M6.5 12h14.5" />
  </React.Fragment>,
  'SendMessage'
)

export default styled(SendMessageIcon)`
  fill: transparent;
  path {
    transform: translate(3px, 3px);
  }
`
